// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#222","pageWidth":"1200","pageWidthPx":"1200px","page-title":"styles-module--page-title--1l7Q-","pageTitle":"styles-module--page-title--1l7Q-"};